<div [formGroup]="currentFormGroup">
  <div class="flex flex-wrap">
    <div class="col-12">
      <div class="flex flex-wrap justify-content-between">
        <div class="col-12 lg:col-4">
          <tj-field label="Net amount" [control]="fcNetAmount">
            <tj-money-input formControlName="netAmount" placeholder="Enter amount" (input)="onNetAmountChange()"></tj-money-input>
          </tj-field>
          
        </div>
        <div class="col-12 lg:col-8 grid">
          <div class="col-5 align-content-center">
            <p-checkbox
              name="applyTax"
              formControlName="applyTax"
              binary="true"
              label="Apply tax"
            ></p-checkbox>
          </div>
          <div class="col-6 col-offset-1">
            <tj-field label="Tax rate" [control]="fcTaxRate">
              <tj-percentage-input
                [disabled]="fcApplyTax.value === false"
                formControlName="taxRate"
                placeholder="0"
              ></tj-percentage-input>
            </tj-field>
          </div>
          <div class="col-5 align-content-center">
            <p-checkbox
              name="applyCCFee"
              formControlName="applyCCFee"
              binary="true"
              label="Apply credit card fee"
            ></p-checkbox>
          </div>
          <div class="col-6 col-offset-1">
            <tj-field label="Credit card fee" [control]="fcCCFeeRate">
              <tj-percentage-input
                formControlName="ccFeeRate"
                [disabled]="fcApplyCCFee.value === false"
              ></tj-percentage-input>
            </tj-field>
          </div>
        </div>

        <div class="col-12 grid">
          <div class="col-4">
            <tj-field label="Paying for" [control]="fcNetTerm">
              <p-dropdown
                [options]="itemTypes"
                formControlName="itemType"
                readonly="true"
              ></p-dropdown>
            </tj-field>
          </div>
          <div class="col-8 lg:col-5">
            <tj-field label="Number" [control]="fcInvoice">
              <input pInputText autocomplete="off" type="text" formControlName="invoiceId" />
            </tj-field>
          </div>
        </div>

        <div class="col-12">
          <tj-field label="Description" [control]="fcDescription">
            <input pInputText autocomplete="off" type="text" formControlName="description" />
          </tj-field>
        </div>

        <div class="col-12 lg:col-6">
          <tj-field label="Customer Name" [control]="fcCustomerName">
            <input pInputText autocomplete="off" type="text" formControlName="customerName" />
          </tj-field>
        </div>

        <div class="col-12 lg:col-6">
          <tj-field label="Email" [control]="fcEmail">
            <input pInputText autocomplete="off" type="email" formControlName="email" />
          </tj-field>
        </div>

        <div class="col-12">
          <tj-field label="Address" [control]="fcAddress">
            <input pInputText autocomplete="off" type="text" formControlName="address" />
          </tj-field>
        </div>
      </div>
    </div>
  </div>

  <tj-payment-summary
    [netAmount]="paymentDetails.netAmount"
    [ccFee]="paymentDetails.ccFee"
    [total]="paymentDetails.total"
    [taxAmount]="paymentDetails.taxFee"
    [showTax]="paymentDetails.applyTax"
    [showCCFee]="paymentDetails.applyCCFee"
    [taxRate]="paymentDetails.taxRate"
  ></tj-payment-summary>

  <div class="flex justify-content-end mt-4">
    <button
      pButton
      label="Next"
      type="button"
      class="button primary"
      (click)="onNext()"
    ></button>
  </div>
</div>
